// extracted by mini-css-extract-plugin
module.exports = {"container":"Workspace_container__ocFtk","loading":"Workspace_loading__2q61R","iframe":"Workspace_iframe__2BP42","error":"Workspace_error__1F-Fq"};